import React from "react";
import Select from "react-select";

const discipline_type = [
  { value: 0, label: "gp" },
  { value: 1, label: "gp_trainee" },
  { value: 2, label: "nurse" },
  { value: 3, label: "consultant" },
  { value: 4, label: "hospital_doctor" },
  { value: 6, label: "nurse_specialist" },
  { value: 7, label: "allied_healthcare_professional" },
];

const disciplineTypes = [
  { value: "gp", label: "GP" },
  { value: "gp_trainee", label: "GP Trainee" },
  { value: "nurse", label: "Nurse" },
  { value: "consultant", label: "Consultant" },
  { value: "hospital_doctor", label: "NCHD (Hospital Doctor)" },
  {},
  { value: "nurse_specialist", label: "Nurse Specialist/ANP" },
  {
    value: "allied_healthcare_professional",
    label: "Allied Healthcare Professional",
  },
  { value: "pharmacist", label: "Pharmacy" },
  // { value: "midwifery", label: "Midwife" },
  // { value: "registered_general_nurses", label: "Registered General Nurse" },
];

class RoleTagSelect extends React.Component {
  render() {
    const { value, onChange, errors } = this.props;

    return (
      <div>
        <div className="col s12">
          <Select
            options={disciplineTypes}
            placeholder="Select roles"
            value={value}
            onChange={onChange}
            multi={true}
          />
          <div style={{ color: "red", fontSize: "0.875rem" }}>
            {(errors || []).join(". ")}
          </div>
        </div>
      </div>
    );
  }
}

export default RoleTagSelect;



// WEBPACK FOOTER //
// ./src/containers/Input/DisciplineRoles.jsx